import { Component, OnInit } from '@angular/core';

import { Router, ActivatedRoute } from '@angular/router';
import {DialogService} from 'primeng/api';
import { NewmemberService } from '../../services/newmember.service';
import { DatePipe, Location } from '@angular/common';
import {DynamicDialogRef} from 'primeng/api';
import {MemberListService} from '../../services/memberlist.service';
import domtoimage from 'dom-to-image';
import { OtppopupComponent } from '../otppopup/otppopup.component';
import {DynamicDialogConfig} from 'primeng/api';

@Component({
  selector: 'app-member-print',
  templateUrl: './member-print.component.html',
  styleUrls: ['./member-print.component.css'],
  providers: [DialogService]
})
export class MemberPrintComponent implements OnInit {

  member: any = {};
  primaryMemberInfo: any = {};
  addOnMemberInfo: Object[] = [];
  expiredOraboutToExpire:boolean = false;
  verified:boolean = false;
  photo:string;
  am: any = {};
  addr: any = {};
  addonList: any = [];
  pm:any = {};
  maId:number;
  bi:any = {};
  constructor(public memberService: MemberListService, public config: DynamicDialogConfig, public ref: DynamicDialogRef, private datePipe: DatePipe,
    private activatedRoute: ActivatedRoute,
    private router: Router, public dialogService: DialogService, public nms: NewmemberService) { }

  ngOnInit() {
    this.addr = this.config.data.address;
    this.pm = this.config.data.pm;
    this.addonList = this.config.data.addonList;
    this.maId = this.config.data.maId;
    this.bi = this.config.data.bi;
       
        this.nms.setDefault(null, this.maId, null);
        var currDate  = new Date(localStorage.getItem("currDate"));          

       
        this.addOnMemberInfo = this.addonList;
        this.primaryMemberInfo = this.pm;

        this.memberService.getMemberActiveInfo(this.maId, null, null).subscribe((res: any) => {
          if (res.code=="SUCCESS") {      
            this.member = res.response;
            this.nms.setDefault(this.member.membershipNbr, this.member.maMembershipId, this.member.currStatCode);
            var currDate  = new Date(localStorage.getItem("currDate"));          
            var expiryDate = new Date(this.member.expirationDate); 
            expiryDate.setDate(expiryDate.getDate() - 15);
            if (this.member.currStatCode == "E" || this.member.currStatCode == "D" || (this.member.expirationDate &&
            currDate >= expiryDate)) {
                this.expiredOraboutToExpire = true;
            }
            var cardholderInfoList = res.response.cardHolderInfo;
            this.addOnMemberInfo = [];
            for (var index = 0; index < cardholderInfoList.length; index++) {
              if(cardholderInfoList[index].cardHolderType == "P") {
                this.primaryMemberInfo = cardholderInfoList[index];
              } else {
                this.addOnMemberInfo.push(cardholderInfoList[index]);
              }
            }

            var documentId = null;
            if(this.primaryMemberInfo.cardHolderDocuments != null) {
              for (let documentInfo of this.primaryMemberInfo.cardHolderDocuments) {      
                if (documentInfo.documentType == "PHOTO") {
                  documentId = documentInfo.documentId;
                }
              }
            }
            if (documentId != null) {
              this.nms.fetchFiles(documentId).subscribe((res: any) => {
                if (res.code=="SUCCESS") {      
                  for(let list of res.response.filesList) {
                    let temp:any = {};
                    temp.vaultId = list.vaultId;
                    this.photo = list.file;
                  }
                }
              });
            }
            
          }
        });
 
  }

  finalVerify() {
    var otpInfo: any = {};
    otpInfo.phoneNbr = this.primaryMemberInfo.phoneNbr;
    otpInfo.maMembershipId = this.primaryMemberInfo.maMembershipId;
    otpInfo.category = "ONBOARDING_CONFIRM_OTP";
    const ref2 = this.dialogService.open(OtppopupComponent, {
      data: otpInfo,
      header: 'OTP Verification',
      width: '90%',
      height: '55%',
      closeOnEscape: false,
      styleClass: 'print_otp_fix',
    });
    ref2.onClose.subscribe((status: any) => {
      if (status) {
        this.verified = true;
      }
    });
  }

  printPreview() {
    var node = document.getElementById('previewPage');
    domtoimage.toPng(node).then(function (dataUrl) {
      var temp = document.getElementById('memberPreview');
      if(temp) {
        document.body.removeChild(temp);
      }
      var image = new Image();
      image.src = dataUrl;
      image.id = "memberPreview";
      image.style.display = "none";
      document.body.appendChild(image);
      setTimeout(() => {
        window.print();
      }, 500);
    })
  }

  confirmBut()  {
    this.nms.submitMember().subscribe((res: any) => {
      if (res.code == "SUCCESS") {
        this.ref.close();
        this.router.navigateByUrl("/app-initiated");
      }
    }, err => {
      console.error('ERROR', err);
    });
  }
 

}
